








































































































































































































































import {
  computed,
  defineComponent, PropType,
} from '@nuxtjs/composition-api';

import { SimpleImage } from '~/components/common/SimpleImage';
import CompatibleSaves from '~/components/CompatibleSaves.vue';
import ProductDelivery from '~/components/Delivery.vue';
import SvgImage from '~/components/General/SvgImage.vue';
import ProductPrice from '~/components/Price.vue';
import PrintHoverText from '~/components/PrintHoverText.vue';
import ListingBullets from '~/components/ProductBullets/ListingType/ListingType.vue';
import PrinterBullets from '~/components/ProductBullets/PrinterType/PrinterType.vue';
import ReviewsBar from '~/components/ReviewsBar.vue';
import ProductStock from '~/components/Stock/Stock.vue';
import Yields from '~/components/Yields/Yields.vue';
import {
  BestValue, useCompatibleTitle, usePageHelpers,
} from '~/composables';
import { PRINTERS_CATEGORY_ID } from '~/constants';
import isServer from '~/helpers/isServer';
import {
  getProductPath,
  isGenuine, isPrinter,
} from '~/helpers/productHelpers';
import { ProductInterface } from '~/modules/GraphQL/types';

import ProductTileName from './components/Name.vue';

export default defineComponent({
  name: 'ProductTile',
  components: {
    ProductTileName,
    ReviewsBar,
    ListingBullets,
    PrinterBullets,
    CompatibleSaves,
    SimpleImage,
    Yields,
    ProductDelivery,
    ProductPrice,
    ProductStock,
    SvgImage,
    PrintHoverText,
  },
  props: {
    product: {
      type: Object as PropType<ProductInterface>,
      required: true,
    },
    isCrossSell: {
      type: Boolean,
      default: false,
    },
    isOnlyImage: {
      type: Boolean,
      default: false,
    },
    bestValues: {
      type: Array as PropType<BestValue[]>,
      default: () => ([]),
    },
    isListingPage: {
      type: Boolean,
      default: false,
    },
    noLazyLoad: {
      type: Boolean,
      default: false,
    },
    categoryId: {
      type: [Number, String],
      default: '',
    },
    categoryName: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { isPrinterPage, isSearchPage } = usePageHelpers();
    const isLayered = isPrinterPage || isSearchPage;
    const { compatibleTitle } = useCompatibleTitle(props.product);

    const isProductGenuine = computed(() => isGenuine(props.product));
    const isListingProduct = computed<boolean>(() => props.isListingPage || isPrinter(props.product));
    const isPrinterProduct = computed<boolean>(() => isPrinter(props.product));
    const currentRating = computed(() => (!props.product.rating_summary ? 0 : +((props.product.rating_summary * 5) / 100).toFixed(1)));
    const reviewsTotal = computed(() => props.product.review_count);
    const isListing = computed(() => isPrinterPage.value || isSearchPage.value);
    const bestValueType = computed(() => props.bestValues?.find((value) => value.product_id === props.product.id)?.type_id);
    const productCategoryId = computed(() => {
      const breadcrumbs = props.product.categories?.[0]?.breadcrumbs;
      const breadcrumbCategoryId = breadcrumbs?.pop()?.category_id;
      const printersCategoryId = isPrinterProduct.value ? PRINTERS_CATEGORY_ID : '';

      return props.categoryId || breadcrumbCategoryId || printersCategoryId;
    });
    const hasCompatibleSaves = computed(() => !isProductGenuine.value && props.product?.alternative_product?.stock?.is_in_stock);

    return {
      isProductGenuine,
      isListingProduct,
      isListing,
      compatibleTitle,
      currentRating,
      reviewsTotal,
      isSearchPage,
      isPrinterProduct,
      bestValueType,
      productCategoryId,
      isLayered,
      hasCompatibleSaves,
      clientSide: computed(() => !isServer),
      getProductPath,
    };
  },
});
